// @ts-strict-ignore
import type { Option } from '@usealloy/component-library';
import { SERVICE_FAILURE_DEFAULT_LABELS } from './constants';
import type { Action } from '~/dashboard/views/workflows/store/engine/types';
import type { ServiceOption } from './types';
import { generatePublicId } from 'flow/service/publicIds';


export function createServiceOption({ key, value }: {
  key?: string;
  value?: string;
} = {}): ServiceOption {
  return {
    key: key ?? '',
    value: value ?? '',
    jsonValue: null,
    publicId: generatePublicId('actionoption'),
    serviceConfigOptionId: null,
    selectedValues: null,
  };
}

export function getServiceFailureDefaultOptions(): Option[] {
  return Object.values(SERVICE_FAILURE_DEFAULT_LABELS).map(label => ({
    label,
    value: label,
  }));
}

// form helpers:
export function buildServiceFailureDefaultOption(value: Action['serviceFailureDefault']): Option {
  switch (value) {
    case true:
      return {
        label: SERVICE_FAILURE_DEFAULT_LABELS.RUN_SERVICE,
        value: SERVICE_FAILURE_DEFAULT_LABELS.RUN_SERVICE,
      };
    case false:
      return {
        label: SERVICE_FAILURE_DEFAULT_LABELS.DO_NOT_RUN_SERVICE,
        value: SERVICE_FAILURE_DEFAULT_LABELS.DO_NOT_RUN_SERVICE,
      };
    case null:
      return {
        label: SERVICE_FAILURE_DEFAULT_LABELS.EXIT_WORKFLOW,
        value: SERVICE_FAILURE_DEFAULT_LABELS.EXIT_WORKFLOW,
      };
    default:
      return null;
  }
}

export function convertActionOptionsToServiceOptions(
  serviceOptions: Action['options'],
): ServiceOption[] {
  return Object.entries(serviceOptions).map(([key, value]) => ({
    ...value,
    key,
    value: value.value as string,
  }));
}

export function convertServiceOptionToActionOption(
  values: ServiceOption[],
): Action['options'] {
  if (!values) {
    return {};
  }
  const options: Action['options'] = {};
  values.forEach(({ key, ...rest }) => {
    options[key] = { ...rest };
  });
  return options;
}
